import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { MessageService } from '@services/message.service';
import { LancamentosLoteImportacaoParaDesfazer } from '../../models/lancamentos-lote-importacao-para-desfazer';
import { DesfazerImportacaoApiService } from '../../services/desfazer-importacao-api.service';

@Component({
  selector: 'app-desfazer-importacao-dialog',
  standalone: false,
  templateUrl: './desfazer-importacao-dialog.component.html',
  styleUrl: './desfazer-importacao-dialog.component.scss'
})
export class DesfazerImportacaoDialogComponent implements OnInit {

  contaBancoId: number;
  // Definido apenas no fluxo de cartão, após o usuário escolher o lote na tela anterior.
  // Quando indefinido, desfaz a última importação da conta (fluxo de banco).
  loteImportacaoBancoId?: number;

  dados?: LancamentosLoteImportacaoParaDesfazer;

  get existeLancamentoConciliado(): boolean {
    return !!this.dados?.lancamentos.some(l => l.conciliado);
  }

  constructor(
    private desfazerImportacaoApiService: DesfazerImportacaoApiService,
    private messageService: MessageService,
    private dialogRef: MatDialogRef<DesfazerImportacaoDialogComponent>
  ) { }

  ngOnInit(): void {
    const obs = this.loteImportacaoBancoId
      ? this.desfazerImportacaoApiService.obterLancamentosLoteImportacaoCartao(this.loteImportacaoBancoId)
      : this.desfazerImportacaoApiService.obterLancamentosLoteImportacaoBanco(this.contaBancoId);

    obs.subscribe(dados => this.dados = dados);
  }

  public desfazerClick(): void {
    const obs = this.loteImportacaoBancoId
      ? this.desfazerImportacaoApiService.desfazerImportacaoCartao(this.contaBancoId, this.loteImportacaoBancoId)
      : this.desfazerImportacaoApiService.desfazerUltimaImportacaoBanco(this.contaBancoId);

    obs.subscribe(() => {
      this.messageService.showToastSuccess("Importação desfeita com sucesso.");
      this.dialogRef.close(true);
    });
  }
}
